import tools from './tools.js' //工具
const filter = {
  dateFormat(date, fmt) {
    return tools.dateFormat(date, fmt)
  },
  // 字符串截取
  subString(value, length) {
    if (!value) {
      return "";
    }
    value = value.trim();
    if (value.length > length) {
      var first = value.toString().substring(0, length);
      value = first + "...";
    }
    return value;
  },
  // 字符串截取
  timeSub(value, endLength) { //
    if (!value) return;
    return value.substring(0, endLength);
  },
  //与被保险人关系
  filterRelationShip(num) {
    const m = new Map([
      ['1', "本人"],
      ['2', "父母"],
      ['3', "子女"],
      ['4', "配偶"],
      ['5', "兄弟姐妹"],
      ['6', "祖父母，外祖父母"],
      ['7', "祖孙，外祖孙"],
      ['8', "其他"],
      ['9', "丈夫"],
      ['10', "妻子"],
      ['11', "父亲"],
      ['12', "母亲"],
      ['13', "儿子"],
      ['14', "女儿"],
      ['15', "孙子"],
      ['16', "孙女"],
      ['17', "外孙"],
      ['18', "外孙女"],
      ['30','孙子女'],
      ['31','外孙子女'],
    ]);
    return m.get(num + '')
  },
  // 证件类型 过滤
  identifyType(val) {
    var value = "";
    if(!val)return '';
    val=Number(val);
    switch (val) {
      case 1:
        value = '身份证';
        break;
      case 2:
        value = '护照';
        break;
      case 3:
        value = '军人证';
        break;
      case 4:
        value = '出生证';
        break;
      case 5:
        value = '港澳台同胞证';
        break;
      case 6:
        value = '户口本';
        break;
      case 7:
        value = '港澳居民来往内地通行证';
        break;
      case 8:
        value = '港澳台通行证';
        break;
      case 9:
        value = '出生证明';
        break;
      case 10:
        value = '企业三合一证';
        break;
      case 11:
        value = "组织机构代码"
        break;
      case 12:
        value = "工商注册号"
        break;
      case 13:
        value = "统一社会信用代码"
        break;
      case 14:
        value = "港澳居民居住证"
        break;
      case 15:
        value = "台湾居民居住证"
        break;
      case 16:
        value = "台湾居民来往内地通行证"
        break;
      case 17:
        value = "港澳台居民居住证"
        break;
      case 18:
        value = "外国护照"
        break;
      case 99:
        value = '其它';
        break;
    }
    return value;
  },
  /**
   * 
   * @param {*} val 
   * @returns 2021/05/14
   */
  timeSplit(val){
    if(val){
      try {
        if(val.split(' ').length==2){
          let timeArr = val.replace(/-/g, "/").split(" ")
          return timeArr[0]
        }else if(val.split(' ').length==1){
          let time = val.replace(/-/g, "/")
          return time
        }else{
          return '-'
        }
      } catch (error) {
        console.log(error)
        console.log('%c时间格式','color:red',val)
      }
    }
    return '-'
  },
  /**
   * 
   * @param {*} val 
   * @returns 2021/05/14 06：05   || 2021/05/14
   */
  timeStatus(val){
    try {
        if(val){
            if(val.split(' ').length==2){
                let timeArr = val.replace(/-/g, "/").split(":")
                return timeArr[0] + ":" + timeArr[1]
            }else if(val.split(' ').length==1){
                let time = val.replace(/-/g, "/")
                return time
            }else{
                return '-'
            }
        }
    } catch (error) {
        console.log(error)
        console.log('%c时间格式','color:red',val)
    }
    return '-'
},
}

export default filter
